import { FaceRect } from '@d-id/types';
import { ImageElementType } from 'polotno/model/image-model';

export const getSquareFaceData = (avatarElement: ImageElementType | undefined, faceRect: FaceRect | undefined | null) => {
    const padding = 0.6;

    if (!faceRect) return;

    const imageWidth = avatarElement?.custom?.originalWidth;
    const imageHeight = avatarElement?.custom?.originalHeight;

    const { top, left, bottom, right } = faceRect;

    // Calculate the face rectangle dimensions
    const faceWidth = right - left;
    const faceHeight = bottom - top;

    // Took face bigger dimensions and added padding
    const faceMax = Math.max(faceWidth, faceHeight) * (1 + padding);

    // Calculated face size
    const faceSize = Math.min(imageWidth, imageHeight, faceMax);

    // Face center
    const faceCenterX = left + faceWidth / 2;
    const faceCenterY = top + faceHeight / 2;

    // Crop center
    const cropCenterX = Math.max(faceCenterX, faceSize / 2);
    const cropCenterY = Math.max(faceCenterY, faceSize / 2);

    // Calculate new crop rectangle
    const cropLeft = Math.max(0, cropCenterX - faceSize / 2);
    const cropTop = Math.max(0, cropCenterY - faceSize / 2);
    const cropRight = Math.min(imageWidth, cropCenterX + faceSize / 2);
    const cropBottom = Math.min(imageHeight, cropCenterY + faceSize / 2);

    // Convert to crop tool format (normalized to 0-1 scale)
    const cropXRatio = cropLeft / imageWidth;
    const cropYRatio = cropTop / imageHeight;
    const cropWidth = cropRight - cropLeft;
    const cropHeight = cropBottom - cropTop;
    const cropWidthRatio = cropWidth / imageWidth;
    const cropHeightRatio = cropHeight / imageHeight;

    return {
        cropXRatio,
        cropYRatio,
        cropWidth,
        cropHeight,
        cropWidthRatio,
        cropHeightRatio,
    };
};
